module.exports = __webpack_public_path__ + "assets/9ceea12dc6f110442dbf0ef580600a7a.svg";